import React from 'react';
import { Box } from '@mui/material';

function InfoRow({ label, value, highlight }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 1,
        py: 0.25,
      }}
    >
      <Box
        component="span"
        sx={{
          flexShrink: 0,
          minWidth: '2.5rem',
          fontSize: '13px',
          color: '#918A8A',
          fontWeight: 500,
        }}
      >
        {label}
      </Box>
      <Box
        component="span"
        sx={{
          flex: 1,
          textAlign: 'right',
          fontSize: '14px',
          fontWeight: highlight ? 700 : 500,
          color: highlight ? '#DD8B44' : '#3A3A3A',
          wordBreak: 'break-all',
        }}
      >
        {value || '-'}
      </Box>
    </Box>
  );
}

export default function WorkStopPersonInfo({ person }) {
  if (!person) return null;

  const dep = person.depNmLast?.trim() || '-';
  const pos = person.position?.trim() || '-';
  const name = person.name?.trim() || '-';

  return (
    <Box
      sx={{
        backgroundColor: '#fafafa',
        borderRadius: 1,
        border: '1px solid #EFEFEF',
        p: 1.25,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.25,
      }}
    >
      <InfoRow label="부서" value={dep} />
      <InfoRow label="직위" value={pos} />
      <InfoRow label="성명" value={name} highlight />
    </Box>
  );
}
